<app-header *ngIf="isDataLoaded" [isHome]=true></app-header>


<app-hero *ngIf="isDataLoaded" [homeHero_params]="homeData.heroHome_params">
</app-hero>

<!-- <app-hero-video *ngIf="isDataLoaded" [homeHero_params]="hero_video_params">
</app-hero-video> -->


<!-- <div class="container">
    <div class="row">
        <div data-aos="fade-right" data-aos-duration="1500" data-delay="200" class="col-lg-6 col-md-12 col-sm-12 col-12 video px-lg-5 px-md-0 mb-lg-2 quienes-blq-inner-int quienes-blq-inner2 
               d-flex align-items-center video-left">
            <app-one-col-area-nobutton [oneColAreaNoButton_params]="oneColAreaNoButton_params">
            </app-one-col-area-nobutton>
        </div>
        <div class="mt-5 col-lg-6 col-md-12 col-sm-12 col-12 video px-lg-5 px-md-0 mb-lg-2 aos-init aos-animate">
            <app-video-auto [videoAuto_params]="videoAuto_params">
            </app-video-auto>
        </div>
    </div>
</div> -->


<section id="quienes" *ngIf="isDataLoaded" class="reset-section-pad3">

    <div class="container">
        <div class="row">
            <div class="col-lg-12 quienes-blq mb-lg-flex-dir-col">

                <div data-aos="fade-right" data-aos-duration="1500"
                    class="col-lg-6 col-md-12 col-sm-12 col-12 quienes-blq-inner">
                    <div class="col-lg-12 d-flex quienes-blq-inner-int mb-flex-dir-col">
                        <app-two-col-area [twoColArea_params]="homeData.twoColArea_params"></app-two-col-area>
                    </div>
                    <div class="col-lg-12 d-flex mt-5">
                        <app-img-big [imgBig_params]="homeData.imgBig_params">
                        </app-img-big>
                    </div>
                </div>

                <div data-aos="fade-up" data-aos-duration="1500" data-delay="200"
                    class="col-lg-6 col-md-12 col-sm-12 col-12 quienes-blq-inner2 px-lg-5 px-md-0 mb-lg-5">
                    <app-one-col-area [oneColArea_params]="homeData.oneColArea_params">
                    </app-one-col-area>

                </div>
            </div>
        </div>
    </div>

</section>

<section id="datos" class="bg-dark" *ngIf="isDataLoaded">
    <div class="container">

        <div class="row">
            <app-counterup [counterUp_params]="homeData.counterUp_params"></app-counterup>
        </div>
    </div>

</section>

<section id="equipo" class="bg-grey" *ngIf="isDataLoaded">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 equipo-blq">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 equipo-blq-inner mb-md-flex-dir-col">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <app-linewords [lineWords_params]="homeData.lineWords_params"></app-linewords>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <app-one-col-area-button
                            [oneColAreaButton_params]="homeData.oneColAreaButton_params"></app-one-col-area-button>
                    </div>
                </div>
                <div class="col-lg-5 col-md-12 col-sm-12 col-12 mt-md-5">
                    <div class="col-lg-12 mb-5">
                        <app-carousel-team-home [carouselTeamHome_items]="teamMembers"></app-carousel-team-home>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="marquee" class="bg-light" *ngIf="isDataLoaded">
    <div class="container-fluid">
        <div class="row marquee">

            <div class="col-lg-12 marquee-blq">
                <p class="orig">
                    <span *ngFor="let item of homeData.marqueeHome_items">
                        <span [ngClass]="{'grey': item.grey}">{{item.text}}</span>
                        <span class="preline_spacer">{{homeData.marqueeHome_spacer}}</span>
                    </span>
                </p>
            </div>


            <!-- <app-marquee
                [marqueeHome_items]="marqueeHome_itemsLocal"
                [marqueeHome_spacer]="homeData.marqueeHome_spacer"
            ></app-marquee> -->
        </div>
        <div class="container">
            <div class="col-lg-12 mt-5">
                <app-btn-more [btnMore_params]="homeData.btnMore_params"></app-btn-more>
            </div>
        </div>
    </div>
</section>

<section id="retalk-home" *ngIf="isDataLoaded">
    <div class="container">
        <div class="row">
            <app-three-col-area-button
                [threeColAreaButton_params]="homeData.threeColAreaButton_params"></app-three-col-area-button>
        </div>
        <div class="row">
            <app-carousel-retalk-home [carouselMainImg]="homeData.carouselMainImg"
                [carouselRetalkHome_items]="homeData.carouselRetalkHome_items"
                [podcastNumber]="homePodcast.id"></app-carousel-retalk-home>
        </div>
    </div>
</section>

<section id="casos-esg" *ngIf="isDataLoaded">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 casos-esg mb-lg-flex-dir-col">
                <div class="col-lg-7 col-md-12 col-sm-12 col-12 casos-esg-blq-inner mb-5">
                    <app-two-col-area-photo-button
                        [twoColAreaPhotoButton_params]="caso"></app-two-col-area-photo-button>
                </div>
                <div class="col-lg-5 col-md-12 col-sm-12 col-12 casos-esg-blq-inner">
                    <app-one-col-area-button-h1
                        [oneColAreaButtonH1_params]="homeData.oneColAreaButtonH1_params"></app-one-col-area-button-h1>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-main *ngIf="isDataLoaded" ng s34></app-footer-main>